// src/Sentences.js

import React, { useState } from 'react';
import './Sentences.css';

const sentencesData = {
  "Good morning": {
    telugu: "శుభోదయం",
    hindi: "सुप्रभात",
    tamil: "காலை வணக்கம்",
    kannada: "ಶುಭೋದಯ"
  },
  "How are you?": {
    telugu: "మీరు ఎలా ఉన్నారు?",
    hindi: "आप कैसे हैं?",
    tamil: "நீங்கள் எப்படி இருக்கிறீர்கள்?",
    kannada: "ನೀವು ಹೇಗಿದ್ದೀರಾ?"
  },
 
  "Thank you": {
    telugu: "ధన్యవాదాలు",
    hindi: "धन्यवाद",
    tamil: "நன்றி",
    kannada: "ಧನ್ಯವಾದಗಳು"
  },
  "Please": {
    telugu: "దయచేసి",
    hindi: "कृपया",
    tamil: "தயவுசெய்து",
    kannada: "ದಯವಿಟ್ಟು"
  },
  "Yes": {
    telugu: "అవును",
    hindi: "हाँ",
    tamil: "ஆம்",
    kannada: "ಹೌದು"
  },
  "No": {
    telugu: "కాదు",
    hindi: "नहीं",
    tamil: "இல்லை",
    kannada: "ಇಲ್ಲ"
  },

    "Excuse me": {
      telugu: "క్షమించండి",
      hindi: "मुझे माफ करें",
      tamil: "மன்னிக்கவும்",
      kannada: "ಕ್ಷಮಿಸಿ"
    },
    "What is your name?": {
      telugu: "మీ పేరు ఏమిటి?",
      hindi: "आपका नाम क्या है?",
      tamil: "உங்கள் பெயர் என்ன?",
      kannada: "ನಿಮ್ಮ ಹೆಸರೇನು?"
    },
    "My name is...": {
      telugu: "నా పేరు...",
      hindi: "मेरा नाम है...",
      tamil: "என் பெயர்...",
      kannada: "ನನ್ನ ಹೆಸರು..."
    },
    "I am hungry": {
      telugu: "నాకు ఆకలిగా ఉంది",
      hindi: "मुझे भूख लगी है",
      tamil: "எனக்கு பசிக்குது",
      kannada: "ನನಗೆ ಹಸಿವಾಗಿದೆ"
    },
    "I am thirsty": {
      telugu: "నాకు దాహం వేసింది",
      hindi: "मुझे प्यास लगी है",
      tamil: "எனக்கு தாகம்",
      kannada: "ನನಗೆ ಹಸಿವು"
    },
    "I am tired": {
      telugu: "నేను అలసిపోయాను",
      hindi: "मैं थक गया हूँ",
      tamil: "நான் சோர்ந்துவிட்டேன்",
      kannada: "ನಾನು ದಣಿದಿದ್ದೇನೆ"
    },
    "I need help": {
      telugu: "నాకు సహాయం కావాలి",
      hindi: "मुझे मदद की जरूरत है",
      tamil: "எனக்கு உதவி வேண்டும்",
      kannada: "ನನಗೆ ಸಹಾಯ ಬೇಕು"
    },
    "Where is the bathroom?": {
      telugu: "బాత్రూమ్ ఎక్కడ ఉంది?",
      hindi: "बाथरूम कहाँ है?",
      tamil: "கழிவறை எங்கு உள்ளது?",
      kannada: "ಬಾತ್ ರೂಮ್ ಎಲ್ಲಿದೆ?"
    },
    "Can you help me?": {
      telugu: "మీరు నన్ను సాయపడగలరా?",
      hindi: "क्या आप मेरी मदद कर सकते हैं?",
      tamil: "நீங்கள் எனக்கு உதவ முடியுமா?",
      kannada: "ನೀವು ನನಗೆ ಸಹಾಯ ಮಾಡಬಹುದೇ?"
    },
    "Where are you from?": {
      telugu: "మీరు ఎక్కడి నుండి వచ్చారు?",
      hindi: "आप कहां से हैं?",
      tamil: "நீங்கள் எங்கு இருந்து வந்துள்ளீர்கள்?",
      kannada: "ನೀವು ಎಲ್ಲಿಂದ ಬಂದಿದ್ದೀರಿ?"
    },
    "I don't understand": {
      telugu: "నాకు అర్థం కావట్లేదు",
      hindi: "मुझे समझ नहीं आता",
      tamil: "எனக்கு புரியவில்லை",
      kannada: "ನನಗೆ ಅರ್ಥವಾಗುತ್ತಿಲ್ಲ"
    },
    "I am sorry": {
      telugu: "నన్ను క్షమించండి",
      hindi: "मुझे खेद है",
      tamil: "நான் மன்னிப்பு கேட்கிறேன்",
      kannada: "ನಾನು ವಿಷಾದಿಸುತ್ತೇನೆ"
    },
    "What time is it?": {
      telugu: "సమయం ఎంత?",
      hindi: "समय क्या हुआ है?",
      tamil: "நேரம் என்ன?",
      kannada: "ಇದೀಗ ಸಮಯ ಎಷ್ಟು?"
    },

        "Where is the classroom?": {
          telugu: "తరగతి గది ఎక్కడ ఉంది?",
          hindi: "कक्षा कहाँ है?",
          tamil: "வகுப்பு எங்கு உள்ளது?",
          kannada: "ವರ್ಗ ಕೊಠಡಿ ಎಲ್ಲಿದೆ?"
        },
        "Who is your teacher?": {
          telugu: "మీ ఉపాధ్యాయుడు ఎవరు?",
          hindi: "आपके शिक्षक कौन हैं?",
          tamil: "உங்கள் ஆசிரியர் யார்?",
          kannada: "ನಿಮ್ಮ ಗುರು ಯಾರು?"
        },
        "When is the lunch break?": {
          telugu: "భోజన విరామం ఎప్పుడు?",
          hindi: "दोपहर का भोजन कब है?",
          tamil: "மதிய உணவு இடைவேளை எப்போது?",
          kannada: "ಮಧ್ಯಾಹ್ನ ಊಟದ ವಿಹಾರ ಯಾವಾಗ?"
        },
        "Can I go to the restroom?": {
          telugu: "నేను మరుగుదొడ్డికి వెళ్లగలనా?",
          hindi: "क्या मैं शौचालय जा सकता हूँ?",
          tamil: "நான் கழிவறைக்கு சென்று வரலாமா?",
          kannada: "ನಾನು ಶೌಚಾಲಯಕ್ಕೆ ಹೋಗಬಹುದೇ?"
        },
        "I have a doubt.": {
          telugu: "నాకు సందేహం ఉంది.",
          hindi: "मुझे एक संदेह है।",
          tamil: "எனக்கு சந்தேகம் உள்ளது.",
          kannada: "ನನಗೆ ಸಂಶಯವಿದೆ."
        },
        "Can you explain this again?": {
          telugu: "మీరు దీన్ని మళ్లీ వివరించగలరా?",
          hindi: "क्या आप इसे फिर से समझा सकते हैं?",
          tamil: "நீங்கள் இதை மீண்டும் விளக்க முடியுமா?",
          kannada: "ನೀವು ಇದನ್ನು ಮತ್ತೆ ವಿವರಿಸಬಹುದೇ?"
        },
        "What is today's homework?": {
          telugu: "ఈరోజు గృహపాఠం ఏమిటి?",
          hindi: "आज का गृहकार्य क्या है?",
          tamil: "இன்று வீட்டுப்பாடம் என்ன?",
          kannada: "ಇಂದು ಗೃಹಪಾಠ ಏನು?"
        },
        "When is the exam?": {
          telugu: "పరీక్ష ఎప్పుడు?",
          hindi: "परीक्षा कब है?",
          tamil: "தேர்வு எப்போது?",
          kannada: "ಪರೀಕ್ಷೆ ಯಾವಾಗ?"
        },
        "Can I borrow a pencil?": {
          telugu: "నేను ఒక పెన్సిల్ తీసుకుంటానా?",
          hindi: "क्या मैं एक पेंसिल उधार ले सकता हूँ?",
          tamil: "நான் ஒரு எழுத்துகோல் கடன் வாங்கலாமா?",
          kannada: "ನಾನು ಒಂದು ಪೆನ್ಸಿಲ್ ಧಾರಾಳ ಮಾಡಬಹುದೆ?"
        },
        "Where is the library?": {
          telugu: "గ్రంథాలయం ఎక్కడ ఉంది?",
          hindi: "पुस्तकालय कहाँ है?",
          tamil: "நூலகம் எங்கு உள்ளது?",
          kannada: "ಗ್ರಂಥಾಲಯ ಎಲ್ಲಿದೆ?"
        },
        "What is the school timetable?": {
          telugu: "పాఠశాల సమయ పట్టిక ఏమిటి?",
          hindi: "विद्यालय का समय सारिणी क्या है?",
          tamil: "பள்ளியின் நேர அட்டவணை என்ன?",
          kannada: "ಶಾಲೆಯ ವೇಳಾಪಟ್ಟಿ ಏನು?"
        },
        "Can you help me with this problem?": {
          telugu: "మీరు ఈ సమస్యతో నాకు సహాయం చేయగలరా?",
          hindi: "क्या आप इस समस्या के साथ मेरी मदद कर सकते हैं?",
          tamil: "நீங்கள் இந்த பிரச்சினையுடன் எனக்கு உதவ முடியுமா?",
          kannada: "ನೀವು ಈ ಸಮಸ್ಯೆಯೊಂದಿಗೆ ನನಗೆ ಸಹಾಯ ಮಾಡಬಹುದೇ?"
        },
        "Where is the principal's office?": {
          telugu: "ప్రిన్సిపాల్ కార్యాలయం ఎక్కడ ఉంది?",
          hindi: "प्रधानाचार्य का कार्यालय कहाँ है?",
          tamil: "முதல்வரின் அலுவலகம் எங்கு உள்ளது?",
          kannada: "ಪ್ರಾಚಾರ್ಯದ ಕಚೇರಿ ಎಲ್ಲಿದೆ?"
        },
        "What is the answer to this question?": {
          telugu: "ఈ ప్రశ్నకు సమాధానం ఏమిటి?",
          hindi: "इस प्रश्न का उत्तर क्या है?",
          tamil: "இந்த கேள்விக்கு பதில் என்ன?",
          kannada: "ಈ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರವೇನು?"
        },
        "Can you repeat the question?": {
          telugu: "మీరు ప్రశ్నను మళ్లీ చెప్పగలరా?",
          hindi: "क्या आप प्रश्न को दोहरा सकते हैं?",
          tamil: "நீங்கள் கேள்வியை மீண்டும் கூற முடியுமா?",
          kannada: "ನೀವು ಪ್ರಶ್ನೆಯನ್ನು ಪುನರಾವರ್ತಿಸಬಹುದೇ?"
        },
      
        
            "Can I take leave tomorrow?": {
              telugu: "నేను రేపు సెలవు తీసుకోవచ్చా?",
              hindi: "क्या मैं कल छुट्टी ले सकता हूँ?",
              tamil: "நான் நாளை விடுமுறை எடுக்கலாமா?",
              kannada: "ನಾನು ನಾಳೆ ರಜೆ ತೆಗೆದುಕೊಳ್ಳಬಹುದೇ?"
            },
            "I am not feeling well.": {
              telugu: "నాకు బాగా అనిపించడం లేదు.",
              hindi: "मुझे ठीक नहीं लग रहा है।",
              tamil: "நான் நன்றாக இல்லை.",
              kannada: "ನನಗೆ ಒಳ್ಳೆಯದಾಗಿ ಅನುಭವವಾಗುತ್ತಿಲ್ಲ."
            },
            "I need to see the doctor.": {
              telugu: "నేను డాక్టర్ ను చూడాల్సి ఉంది.",
              hindi: "मुझे डॉक्टर को दिखाना है।",
              tamil: "நான் மருத்துவரை பார்க்க வேண்டும்.",
              kannada: "ನಾನು ವೈದ್ಯರನ್ನು ಭೇಟಿಯಾಗಬೇಕಾಗಿದೆ."
            },
            "Can you give me my textbook?": {
              telugu: "మీరు నాకు నా పాఠ్యపుస్తకం ఇస్తారా?",
              hindi: "क्या आप मुझे मेरी पाठ्यपुस्तक दे सकते हैं?",
              tamil: "நீங்கள் எனக்கு என் பாடப்புத்தகம் தர முடியுமா?",
              kannada: "ನೀವು ನನಗೆ ನನ್ನ ಪಾಠ್ಯಪುಸ್ತಕವನ್ನು ಕೊಡಬಹುದೇ?"
            },
            "I forgot my textbook at home.": {
              telugu: "నేను నా పాఠ్యపుస్తకం ఇంట్లోనే మరిచిపోయాను.",
              hindi: "मैं अपनी पाठ्यपुस्तक घर पर भूल आया।",
              tamil: "நான் என் பாடப்புத்தகத்தை வீட்டில் மறந்துவிட்டேன்.",
              kannada: "ನಾನು ನನ್ನ ಪಾಠ್ಯಪುಸ್ತಕವನ್ನು ಮನೆಯಲ್ಲಿ ಮರೆತಿದ್ದೇನೆ."
            },
       
                "What is your favorite subject?": {
                  telugu: "మీరు ఇష్టపడే విషయం ఏమిటి?",
                  hindi: "आपका पसंदीदा विषय क्या है?",
                  tamil: "உங்களுக்குப் பிடித்த பாடம் என்ன?",
                  kannada: "ನಿಮ್ಮ ಮೆಚ್ಚಿನ ವಿಷಯ ಯಾವುದು?"
                },
                "Why are you late to class?": {
                  telugu: "మీరు తరగతికి ఎందుకు ఆలస్యంగా వచ్చారు?",
                  hindi: "आप कक्षा में देर से क्यों आए?",
                  tamil: "நீங்கள் வகுப்புக்கு ஏன் தாமதமாக வந்தீர்கள்?",
                  kannada: "ನೀವು ತರಗತಿಗೆ ತಡವಾಗಿ ಬಂದದು ಯಾಕೆ?"
                },
                "Which book do you need?": {
                  telugu: "మీకు ఏ పుస్తకం కావాలి?",
                  hindi: "आपको कौनसी किताब चाहिए?",
                  tamil: "உங்களுக்கு எந்தப் புத்தகம் வேண்டும்?",
                  kannada: "ನಿಮಗೆ ಯಾವ ಪುಸ್ತಕ ಬೇಕು?"
                },
                "How do you solve this problem?": {
                  telugu: "ఈ సమస్యను మీరు ఎలా పరిష్కరిస్తారు?",
                  hindi: "आप इस समस्या को कैसे हल करेंगे?",
                  tamil: "இந்தப் பிரச்சினையை நீங்கள் எப்படி தீர்ப்பீர்கள்?",
                  kannada: "ಈ ಸಮಸ್ಯೆಯನ್ನು ನೀವು ಹೇಗೆ ಪರಿಹರಿಸುತ್ತೀರಿ?"
                },
                "Whose pen is this?": {
                  telugu: "ఇది ఎవరి పెన్?",
                  hindi: "यह किसका पेन है?",
                  tamil: "இது யாருடைய பேனா?",
                  kannada: "ಇದು ಯಾರ ಪೆನ್?"
                },
                "What did you learn today?": {
                  telugu: "ఈరోజు మీరు ఏమి నేర్చుకున్నారు?",
                  hindi: "आपने आज क्या सीखा?",
                  tamil: "நீங்கள் இன்று என்ன கற்றுக்கொண்டீர்கள்?",
                  kannada: "ಇಂದು ನೀವು ಏನು ಕಲಿತಿರಿ?"
                },
                "Why did you miss school?": {
                  telugu: "మీరు పాఠశాలకు ఎందుకు రాలేదని?",
                  hindi: "आपने स्कूल क्यों छोड़ा?",
                  tamil: "நீங்கள் பள்ளிக்கு ஏன் வரவில்லை?",
                  kannada: "ನೀವು ಶಾಲೆಗೆ ಹೋಗದಿದ್ದಲ್ಲಿ ಯಾಕೆ?"
                },
                "Which chapter are we on?": {
                  telugu: "మనం ఏ అధ్యాయంలో ఉన్నాము?",
                  hindi: "हम किस अध्याय पर हैं?",
                  tamil: "நாம் எந்த அத்தியாயத்தில் இருக்கிறோம்?",
                  kannada: "ನಾವು ಯಾವ ಅಧ್ಯಾಯದಲ್ಲಿದ್ದೇವೆ?"
                },
                "How do you find the answer?": {
                  telugu: "సమాధానం ఎలా కనుగొనవచ్చు?",
                  hindi: "आप उत्तर कैसे पाते हैं?",
                  tamil: "நீங்கள் விடையை எப்படி கண்டுபிடிக்கிறீர்கள்?",
                  kannada: "ನೀವು ಉತ್ತರವನ್ನು ಹೇಗೆ ಕಂಡುಕೊಳ್ಳುತ್ತೀರಿ?"
                },
                "Whose bag is this?": {
                  telugu: "ఇది ఎవరి బ్యాగు?",
                  hindi: "यह किसका बैग है?",
                  tamil: "இது யாருடைய பை?",
                  kannada: "ಇದು ಯಾರ ಬ್ಯಾಗ್?"
                },
              




            "I need permission to leave early.": {
              telugu: "నేను ముందుగానే వెళ్లటానికి అనుమతి కావాలి.",
              hindi: "मुझे जल्दी छुट्टी की अनुमति चाहिए।",
              tamil: "நான் முன்கூட்டியே விடுபட அனுமதி தேவை.",
              kannada: "ನಾನು ಮುಂಚಿತವಾಗಿ ಬಿಡಲು ಅನುಮತಿ ಬೇಕಿದೆ."
            },
            "Can I submit my assignment later?": {
              telugu: "నేను నా అసైన్మెంట్ తర్వాత సమర్పించవచ్చా?",
              hindi: "क्या मैं अपना असाइनमेंट बाद में जमा कर सकता हूँ?",
              tamil: "நான் என் ஒப்பந்தத்தை பின்னர் சமர்ப்பிக்கலாமா?",
              kannada: "ನಾನು ನನ್ನ ಅಸೈನ್‌ಮೆಂಟ್ ಅನ್ನು ನಂತರ ಸಲ್ಲಿಸಬಹುದೇ?"
            },
            "I have a doctor's appointment.": {
              telugu: "నా దగ్గర డాక్టర్ అపాయింట్మెంట్ ఉంది.",
              hindi: "मुझे डॉक्टर के पास अपॉइंटमेंट है।",
              tamil: "எனக்கு மருத்துவரிடம் சந்திப்பு உள்ளது.",
              kannada: "ನನಗೆ ಡಾಕ್ಟರ್ ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಇದೆ."
            },
            "Can I get a new textbook?": {
              telugu: "నేను కొత్త పాఠ్యపుస్తకం పొందవచ్చా?",
              hindi: "क्या मुझे एक नई पाठ्यपुस्तक मिल सकती है?",
              tamil: "நான் ஒரு புதிய பாடப்புத்தகம் பெறலாமா?",
              kannada: "ನಾನು ಹೊಸ ಪಾಠ್ಯಪುಸ್ತಕವನ್ನು ಪಡೆಯಬಹುದೇ?"
            },
          



            "Can I go to the playground?": {
              telugu: "నేను ప్రాంగణానికి వెళ్లవచ్చా?",
              hindi: "क्या मैं खेल के मैदान में जा सकता हूँ?",
              tamil: "நான் விளையாட்டு மைதானம் செல்லலாமா?",
              kannada: "ನಾನು ಆಟದ ಮೈದಾನಕ್ಕೆ ಹೋಗಬಹುದೇ?"
            },
            "Can I play with you?": {
              telugu: "నేను మీతో ఆడవచ్చా?",
              hindi: "क्या मैं आपके साथ खेल सकता हूँ?",
              tamil: "நான் உங்களுடன் விளையாடலாமா?",
              kannada: "ನಾನು ನಿಮ್ಮ ಜೊತೆಗೆ ಆಟ ಆಡಬಹುದೇ?"
            },
            "Is it time for recess?": {
              telugu: "ఇది విరామ సమయం?",
              hindi: "क्या यह अवकाश का समय है?",
              tamil: "இது இடைவேளை நேரமா?",
              kannada: "ಇದು ವಿಶ್ರಾಂತಿಯ ಸಮಯವೋ?"
            },
            "Can we go outside to play?": {
              telugu: "మేము బయటకు ఆడవచ్చా?",
              hindi: "क्या हम बाहर खेलने जा सकते हैं?",
              tamil: "நாங்கள் வெளியே விளையாட செல்லலாமா?",
              kannada: "ನಾವು ಹೊರಗೆ ಆಟ ಆಡಲು ಹೋಗಬಹುದೇ?"
            },
            "Can I join your game?": {
              telugu: "నేను మీ ఆటలో చేరవచ్చా?",
              hindi: "क्या मैं आपके खेल में शामिल हो सकता हूँ?",
              tamil: "நான் உங்கள் விளையாட்டில் சேரலாமா?",
              kannada: "ನಾನು ನಿಮ್ಮ ಆಟಕ್ಕೆ ಸೇರಬಹುದೇ?"
            },
            "Is it okay to play here?": {
              telugu: "ఇక్కడ ఆడడం సరైనదా?",
              hindi: "क्या यहाँ खेलना ठीक है?",
              tamil: "இங்கே விளையாடுவது சரியா?",
              kannada: "ಇಲ್ಲಿ ಆಟ ಆಡಲು ಸರಿ?"
            },
            "Can I use the swings?": {
              telugu: "నేను ఊయలలు ఉపయోగించవచ్చా?",
              hindi: "क्या मैं झूले का इस्तेमाल कर सकता हूँ?",
              tamil: "நான் ஊஞ்சல்களை பயன்படுத்தலாமா?",
              kannada: "ನಾನು ಬೀಸುವದನ್ನು ಬಳಸಬಹುದೇ?"
            },
            "May I go to the sports field?": {
              telugu: "నేను క్రీడల మైదానానికి వెళ్లవచ్చా?",
              hindi: "क्या मैं खेल के मैदान में जा सकता हूँ?",
              tamil: "நான் விளையாட்டு மைதானம் செல்லலாமா?",
              kannada: "ನಾನು ಕ್ರೀಡಾ ಮೈದಾನಕ್ಕೆ ಹೋಗಬಹುದೇ?"
            },
            "Can I take a break from class?": {
              telugu: "నేను తరగతి నుండి విరామం తీసుకోవచ్చా?",
              hindi: "क्या मैं कक्षा से ब्रेक ले सकता हूँ?",
              tamil: "நான் வகுப்பிலிருந்து இடைவேளை எடுக்கலாமா?",
              kannada: "ನಾನು ತರಗತಿಯಿಂದ ವಿಶ್ರಾಂತಿ ತೆಗೆದುಕೊಳ್ಳಬಹುದೇ?"
            },
            "Can we play a game together?": {
              telugu: "మనం కలిసి ఒక ఆట ఆడవచ్చా?",
              hindi: "क्या हम एक साथ खेल सकते हैं?",
              tamil: "நாம் ஒரு விளையாட்டை ஒன்றாக விளையாடலாமா?",
              kannada: "ನಾವು ಒಂದಾಗಿ ಒಂದು ಆಟ ಆಡಬಹುದೇ?"
            },
          




    "Where is the nearest hospital?": {
      telugu: "మొదటి ఆసుపత్రి ఎక్కడ ఉంది?",
      hindi: "निकटतम अस्पताल कहाँ है?",
      tamil: "அருகில் உள்ள மருத்துவமனை எங்கே?",
      kannada: "ಹತ್ತಿರದ ಆಸ್ಪತ್ರೆ ಎಲ್ಲಿದೆ?"
    },
    "Can I have some water?": {
      telugu: "నాకు కొంచెం నీళ్లు కావాలి?",
      hindi: "क्या मुझे थोड़ा पानी मिल सकता है?",
      tamil: "எனக்கு கொஞ்சம் தண்ணீர் கிடைக்குமா?",
      kannada: "ನನಗೆ ಸ್ವಲ್ಪ ನೀರು ಸಿಗುತ್ತದೆಯೇ?"
    },
    "Where is the nearest bus stop?": {
      telugu: "దగ్గరలో బస్ స్టాప్ ఎక్కడ?",
      hindi: "निकटतम बस स्टॉप कहाँ है?",
      tamil: "அருகிலுள்ள பேருந்து நிறுத்தம் எங்கே?",
      kannada: "ಹತ್ತಿರದ ಬಸ್ ನಿಲ್ದಾಣ ಎಲ್ಲಿದೆ?"
    },
 
    "Can I get the bill?": {
      telugu: "నా బిల్లు ఇవ్వగలరా?",
      hindi: "क्या मुझे बिल मिल सकता है?",
      tamil: "எனக்கு பில் கிடைக்குமா?",
      kannada: "ನನಗೆ ಬಿಲ್ ಸಿಗುತ್ತದೆಯಾ?"
    },
    "Where is the nearest ATM?": {
      telugu: "దగ్గరలో ఏటీఎం ఎక్కడ ఉంది?",
      hindi: "निकटतम एटीएम कहाँ है?",
      tamil: "அருகில் உள்ள ஏடிஎம் எங்கே?",
      kannada: "ಹತ್ತಿರದ ಎಟಿಎಂ ಎಲ್ಲಿದೆ?"
    },
    

        "How old are you?": {
          telugu: "మీ వయస్సు ఎంత?",
          hindi: "आपकी उम्र कितनी है?",
          tamil: "உங்கள் வயது என்ன?",
          kannada: "ನೀವು ಎಷ್ಟು ವಯಸ್ಸಿನವರು?"
        },
        "Where do you live?": {
          telugu: "మీరు ఎక్కడ నివసిస్తారు?",
          hindi: "आप कहाँ रहते हैं?",
          tamil: "நீங்கள் எங்கு வசிக்கிறீர்கள்?",
          kannada: "ನೀವು ಎಲ್ಲಿವೇ ಇರುತ್ತೀರಿ?"
        },
        "What is your favorite color?": {
          telugu: "మీ ఇష్టమైన రంగు ఏమిటి?",
          hindi: "आपका पसंदीदा रंग क्या है?",
          tamil: "உங்களுக்கு பிடித்த நிறம் எது?",
          kannada: "ನಿಮ್ಮ ನೆಚ್ಚಿನ ಬಣ್ಣ ಯಾವುದು?"
        },
        "Do you have any pets?": {
          telugu: "మీకు ఎలాంటి పెంపుడు జంతువులు ఉన్నాయా?",
          hindi: "क्या आपके पास कोई पालतू जानवर है?",
          tamil: "உங்களுக்கு ஏதேனும் செல்லப்பிராணிகள் உள்ளனவா?",
          kannada: "ನಿಮ್ಮ ಬಳಿ ಯಾವುದೇ ಪೇಶೆಗಳು ಇದೆಯೇ?"
        },
        "What is your favorite food?": {
          telugu: "మీరు ఇష్టపడే ఆహారం ఏమిటి?",
          hindi: "आपका पसंदीदा खाना क्या है?",
          tamil: "உங்களுக்கு பிடித்த உணவு எது?",
          kannada: "ನಿಮ್ಮ ನೆಚ್ಚಿನ ಆಹಾರ ಯಾವುದು?"
        },
        "What are you doing?": {
          telugu: "మీరు ఏమి చేస్తున్నారు?",
          hindi: "आप क्या कर रहे हैं?",
          tamil: "நீங்கள் என்ன செய்கிறீர்கள்?",
          kannada: "ನೀವು ಏನು ಮಾಡುತ್ತಿದ್ದೀರಿ?"
        },
   
            "How much does this cost?": {
              telugu: "ఇది ఎంత ఖర్చు అవుతుంది?",
              hindi: "यह कितने का है?",
              tamil: "இது எவ்வளவு செலவாகும்?",
              kannada: "ಇದು ಎಷ್ಟು ವೆಚ್ಚವಾಗುತ್ತದೆ?"
            },
            "Can you give me a discount?": {
              telugu: "మీరు నాకు తగ్గింపు ఇస్తారా?",
              hindi: "क्या आप मुझे छूट दे सकते हैं?",
              tamil: "நீங்கள் எனக்கு தள்ளுபடி தர முடியுமா?",
              kannada: "ನೀವು ನನಗೆ ರಿಯಾಯಿತಿ ಕೊಡಬಲ್ಲಿರಾ?"
            },
          
            "Can you reduce the price?": {
              telugu: "మీరు ధర తగ్గిస్తారా?",
              hindi: "क्या आप कीमत कम कर सकते हैं?",
              tamil: "நீங்கள் விலையை குறைக்க முடியுமா?",
              kannada: "ನೀವು ಬೆಲೆಯನ್ನು ಕಡಿಮೆ ಮಾಡಬಲ್ಲಿರಾ?"
            },
            "I saw this cheaper elsewhere.": {
              telugu: "ఇది వేరే చోట చౌకగా చూసాను.",
              hindi: "मैंने इसे कहीं और सस्ता देखा है।",
              tamil: "நான் இதை மற்ற இடங்களில் குறைந்த விலையில் கண்டேன்.",
              kannada: "ನಾನು ಇದನ್ನು ಬೇರೆಡೆ ಕಡಿಮೆ ಬೆಲೆಯಲ್ಲಿ ನೋಡಿದ್ದೇನೆ."
            },
            "Can you match this price?": {
              telugu: "మీరు ఈ ధరను సరిపోల్చగలరా?",
              hindi: "क्या आप इस कीमत को मैच कर सकते हैं?",
              tamil: "நீங்கள் இந்த விலைக்கு பொருந்துமா?",
              kannada: "ನೀವು ಈ ಬೆಲೆಗೆ ಹೊಂದಿಸಬಹುದೆ?"
            },
            "I am buying multiple items. Can you offer a better price?": {
              telugu: "నేను అనేక వస్తువులను కొనుగోలు చేస్తున్నాను. మీరు మంచి ధర ఇవ్వగలరా?",
              hindi: "मैं कई वस्तुएं खरीद रहा हूं। क्या आप बेहतर कीमत दे सकते हैं?",
              tamil: "நான் பல பொருட்களை வாங்குகிறேன். நீங்கள் சிறந்த விலை தர முடியுமா?",
              kannada: "ನಾನು ಹಲವು ವಸ್ತುಗಳನ್ನು ಖರೀದಿಸುತ್ತಿದ್ದೇನೆ. ನೀವು ಉತ್ತಮ ಬೆಲೆ ನೀಡಬಹುದೇ?"
            },
            "Is there a special deal available?": {
              telugu: "ఏదైనా ప్రత్యేక డీల్ అందుబాటులో ఉందా?",
              hindi: "क्या कोई विशेष डील उपलब्ध है?",
              tamil: "ஏதேனும் சிறப்பு ஒப்பந்தம் உள்ளதா?",
              kannada: "ಯಾವುದಾದರೂ ವಿಶೇಷ ಒಪ್ಪಂದ ಲಭ್ಯವಿದೆಯೆ?"
            },
            "Can I get a bulk purchase discount?": {
              telugu: "నేను భారీ కొనుగోలుకు తగ్గింపు పొందగలనా?",
              hindi: "क्या मुझे बल्क खरीद पर छूट मिल सकती है?",
              tamil: "நான் மொத்தமாக வாங்க தள்ளுபடி பெற முடியுமா?",
              kannada: "ನಾನು ಬಲ್ಕ್ ಪರ್ಚೇಸ್ ಮಾಡಿದರೆ ರಿಯಾಯಿತಿ ಸಿಗುತ್ತದೆಯೇ?"
            },
            "What is your best price?": {
              telugu: "మీ ఉత్తమ ధర ఏమిటి?",
              hindi: "आपकी सबसे अच्छी कीमत क्या है?",
              tamil: "உங்கள் சிறந்த விலை என்ன?",
              kannada: "ನಿಮ್ಮ ಉತ್ತಮ ಬೆಲೆ ಯಾವುದು?"
            },
          
                "How far is this place?": {
                  telugu: "ఈ స్థలం ఎంత దూరం ఉంది?",
                  hindi: "यह जगह कितनी दूर है?",
                  tamil: "இந்த இடம் எவ்வளவு தூரம் உள்ளது?",
                  kannada: "ಈ ಸ್ಥಳ ಎಷ್ಟು ದೂರವಿದೆ?"
                },
                "How long will it take to reach?": {
                  telugu: "ఎంత సమయం పడుతుంది చేరుకోవడానికి?",
                  hindi: "पहुंचने में कितना समय लगेगा?",
                  tamil: "அங்கு செல்வதற்கு எவ்வளவு நேரம் ஆகும்?",
                  kannada: "ಅಲ್ಲಿಗೆ ತಲುಪಲು ಎಷ್ಟು ಸಮಯ ಬೀಳುತ್ತದೆ?"
                },
                "Is it within walking distance?": {
                  telugu: "నడవగలిగే దూరంలో ఉందా?",
                  hindi: "क्या यह चलने की दूरी के भीतर है?",
                  tamil: "இது நடக்கும் தூரத்தில் உள்ளதா?",
                  kannada: "ಇದು ನಡೆದು ಹೋಗಲು ಸಾಧ್ಯವೇ?"
                },
                "Can you show me on the map?": {
                  telugu: "మీరు నాకు మ్యాపులో చూపించగలరా?",
                  hindi: "क्या आप मुझे नक्शे पर दिखा सकते हैं?",
                  tamil: "நீங்கள் எனக்கு வரைபடத்தில் காட்ட முடியுமா?",
                  kannada: "ನೀವು ನನಗೆ ನಕ್ಷೆಯಲ್ಲಿ ತೋರಿಸಬಹುದೇ?"
                },
            
                "Is this a fair price?": {
                  telugu: "ఇది న్యాయమైన ధర అని మీరు అనుకుంటున్నారా?",
                  hindi: "क्या यह उचित मूल्य है?",
                  tamil: "இது நியாயமான விலைதானா?",
                  kannada: "ಇದು ನ್ಯಾಯವಾದ ಬೆಲೆ?"
                },
                "What is the distance between these two points?": {
                  telugu: "ఈ రెండు  మధ్య దూరం ఎంత?",
                  hindi: "इन दो  के बीच की दूरी कितनी है?",
                  tamil: "இந்த இரண்டு புள்ளிகளின் இடைநிலை என்ன?",
                  kannada: "ಈ ಎರಡೂ  ಮಧ್ಯೆ ಎಷ್ಟು ದೂರವಿದೆ?"
                },
                "How do I get there?": {
                  telugu: "నేను అక్కడికి ఎలా చేరుకోగలను?",
                  hindi: "वहाँ कैसे पहुँचें?",
                  tamil: "நான் எங்கு செல்வது?",
                  kannada: "ನಾನು ಅಲ್ಲಿಗೆ ಹೇಗೆ ಹೋಗಬೇಕು?"
                },
                "Can you negotiate the price?": {
                  telugu: "మీరు ధరను చర్చించగలరా?",
                  hindi: "क्या आप मूल्य पर बातचीत कर सकते हैं?",
                  tamil: "நீங்கள் விலையை பேச்சுவார்த்தை செய்ய முடியுமா?",
                  kannada: "ನೀವು ಬೆಲೆಯನ್ನು ಚರ್ಚಿಸಬಹುದೆ?"
                },
                "How much is the fare?": {
                  telugu: "కిరాయి ఎంత?",
                  hindi: "किराया कितना है?",
                  tamil: "கட்டணம் எவ்வளவு?",
                  kannada: "ಭಾಡಿ ಎಷ್ಟು?"
                },
              
              
     
      
      
  // Add more sentences as needed
};

const Sentences = () => {
  const [selectedSentence, setSelectedSentence] = useState('Good morning');
  const [language, setLanguage] = useState('');

  const handleSentenceChange = (e) => {
    setSelectedSentence(e.target.value);
  };

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    const sentence = sentencesData[selectedSentence][lang];
    const utterance = new SpeechSynthesisUtterance(sentence);
    utterance.lang = getLangCode(lang);
    speechSynthesis.speak(utterance);
  };

  const getLangCode = (lang) => {
    switch (lang) {
      case 'telugu':
        return 'te-IN';
      case 'hindi':
        return 'hi-IN';
      case 'tamil':
        return 'ta-IN';
      case 'kannada':
        return 'kn-IN';
      default:
        return 'en-US';
    }
  };

  return (
    <div className="sentences">
      <h1>Simple English Sentences for Kids</h1>
      <div>
        <label>
          Select Sentence:
          <select value={selectedSentence} onChange={handleSentenceChange}>
            {Object.keys(sentencesData).map((sentence) => (
              <option key={sentence} value={sentence}>{sentence}</option>
            ))}
          </select>
        </label>
      </div>
      <div className="translations">
        <div>
          <h2>Telugu: {sentencesData[selectedSentence].telugu}</h2>
          <button onClick={() => handleLanguageChange('telugu')}>Read Aloud</button>
        </div>
        <div>
          <h2>Hindi: {sentencesData[selectedSentence].hindi}</h2>
          <button onClick={() => handleLanguageChange('hindi')}>Read Aloud</button>
        </div>
        <div>
          <h2>Tamil: {sentencesData[selectedSentence].tamil}</h2>
          <button onClick={() => handleLanguageChange('tamil')}>Read Aloud</button>
        </div>
        <div>
          <h2>Kannada: {sentencesData[selectedSentence].kannada}</h2>
          <button onClick={() => handleLanguageChange('kannada')}>Read Aloud</button>
        </div>
      </div>
    </div>
  );
};

export default Sentences;
